import React from 'react';
import Style from '../Styles/FirmsStyle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Settings from '../../../Settings/Settings'
import CircularProgress from '@mui/material/CircularProgress';
import {
    Link
  } from "react-router-dom";

export default function CreateFirmPaper(props) {
  const classes = Style();

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }
    console.log(componentMethods)
    const [createAccountFirmName, setCreateAccountFirmName] = React.useState(props.element.shopFirmsName)
    const [createAccountCIF, setCreateAccountCIF] =  React.useState(props.element.shopFirmsCif)
    const [createAccountNoORC, setCreateAccountNoORC] = React.useState(props.element.shopFirmsOrcNumber)
    const [createAccountFirmAddress, setCreateAccountFirmAddress] = React.useState(props.element.shopFirmsAddress)
    const [createAccountFirmBank, setCreateAccountFirmBank] = React.useState(props.element.shopFirmsBank)

    const clearCreateFirmForm = () => {
      setCreateAccountFirmName("")
      setCreateAccountCIF("")
      setCreateAccountNoORC("")
      setCreateAccountFirmAddress("")
      setCreateAccountFirmBank("")
    }
    const createFirmAction = () => {
      let accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
      const requestObject = {
        shopFirmsName: createAccountFirmName,
        shopFirmsCif: createAccountCIF,
        shopFirmsOrcNumber: createAccountNoORC,
        shopFirmsAddress: createAccountFirmAddress,
        shopFirmsBank: createAccountFirmBank
      }
      componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_FIRMS + accountToken,requestObject,'POST',null, (data) => {
        componentMethods.addError(componentConstants.language.LANG_FIRM_SAVED); 
        componentMethods.getUserFirms()
        clearCreateFirmForm()
        componentMethods.setShowAddFirm(false)
      }, {}, false, (data) => {
        componentMethods.addError(componentConstants.language.LANG_FIRM_NOT_SAVED)
      })
    }

  const putFirmAction = () => {
      let accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
      const requestObject = {
        shopFirmsName: createAccountFirmName,
        shopFirmsCif: createAccountCIF,
        shopFirmsOrcNumber: createAccountNoORC,
        shopFirmsAddress: createAccountFirmAddress,
        shopFirmsBank: createAccountFirmBank
      }
      componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_PUT_FIRMS + props.element.shopFirmsID + accountToken,requestObject,'PUT',null, (data) => {componentMethods.addError(componentConstants.language.LANG_FIRM_SAVED); componentMethods.getUserAddresses()}, {}, false, (data) => {componentMethods.addError(componentConstants.language.LANG_ADDRESS_NOT_DELETED)})
    }

  return (
    <form style={classes.root} noValidate autoComplete="off">
        
        <React.Fragment>
            <TextField value={createAccountFirmName} type="text" error={componentMethods.getManagerState().formInvalidFirmName} style={classes.formFullWidth} onChange={(event) => {setCreateAccountFirmName(event.target.value)}} id="CREATE_ACCOUNT_FIRM_NAME" label={componentConstants.language.LANG_FIRM_NAME} fullWidth={true} />
            <TextField value={createAccountCIF} type="text" error={componentMethods.getManagerState().formInvalidCIF} style={classes.formFullWidth} onChange={(event) => {setCreateAccountCIF(event.target.value)}} id="CREATE_ACCOUNT_CIF" label={componentConstants.language.LANG_CREATE_ACCOUNT_CIF} fullWidth={true} />
            <TextField value={createAccountNoORC} type="text" error={componentMethods.getManagerState().formInvalidNoORC} style={classes.formFullWidth} onChange={(event) => {setCreateAccountNoORC(event.target.value)}} id="CREATE_ACCOUNT_NO_ORC" label={componentConstants.language.LANG_CREATE_ACCOUNT_NO_ORC} fullWidth={true} />
            <TextField value={createAccountFirmAddress} type="text" error={componentMethods.getManagerState().formInvalidFirmAddress} style={classes.formFullWidth} onChange={(event) => {setCreateAccountFirmAddress(event.target.value)}} id="CREATE_ACCOUNT_FIRM_ADDRESS" label={componentConstants.language.LANG_CREATE_ACCOUNT_FIRM_ADDRESS} fullWidth={true} />
            <TextField value={createAccountFirmBank} type="text" error={componentMethods.getManagerState().formInvalidFirmBank} style={classes.formFullWidth} onChange={(event) => {setCreateAccountFirmBank(event.target.value)}} id="CREATE_ACCOUNT_FIRM_BANK" label={componentConstants.language.LANG_CREATE_ACCOUNT_FIRM_BANK} fullWidth={true} />
        </React.Fragment>
        {componentMethods.getManagerState().loadingCreateFirm ?
        <CircularProgress />
        :
        <React.Fragment>
          {
                props.editFirm ?
                    <React.Fragment>
                      <Button onClick={putFirmAction} variant="contained" disableElevation color="secondary" fullWidth={true} style={classes.closeButton}>
                          {componentConstants.language.LANG_SAVE_FIRM}
                      </Button>
                    </React.Fragment>
            :
            <Button onClick={createFirmAction} variant="contained" disableElevation color="secondary" fullWidth={true} style={classes.closeButton}>
                {componentConstants.language.LANG_SAVE_FIRM}
            </Button>
          }
        </React.Fragment>
        }
    </form>
  );
}